import { render, staticRenderFns } from "./RoomRightPanel.vue?vue&type=template&id=5731a9a8&scoped=true"
import script from "./RoomRightPanel.vue?vue&type=script&lang=js"
export * from "./RoomRightPanel.vue?vue&type=script&lang=js"
import style0 from "./RoomRightPanel.vue?vue&type=style&index=0&id=5731a9a8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5731a9a8",
  null
  
)

export default component.exports